<template>
  <DaiTarjetaContenedorMapa
    class="fix"
    :es-version-escritorio-en-pantalla-larga="true"
    altura-colapsada="510px"
    etiqueta-colapso="Más información"
    etiqueta-no-colapso="Menos información"
  >
    <Loader v-if="cargando" />

    <template #header>
      <h3 v-width-control="'100%'">Uso de herbicidas 2007</h3>
      <p>
        Haz clic sobre el estado para ver información a nivel municipal
      </p>
      <button class="dai-map-button control-small boton-ver-municipios" 
        @click="verMunicipios()">
        {{ nivelActual==='x-estados'? 'Ver por municipios': 'Ver por estados' }}
      </button>
    </template>

    <DaiMapa ref="mapa"
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]"
      @reset_view="resetMap"
    >
      <DaiCapaXyz />

      <!-- Capa optimizada: 
        Carga información con el atributo :datos solo cuando hay un estado seleccionado
      -->
      <DaiCapaGeojson
        v-if="verCapas"
        :url="cvegeo==undefined? geojsonEstatal: undefined"
        :datos="cvegeo==undefined? undefined: {
          type: 'FeatureCollection',
          features: JSON.parse(estados)
        }"
        :z-index="1"
        :estilo-capa="{
          fill: {color: 'transparent'},
          stroke: {color: '#4CA345', width:1.6},
        }"
        :contenidoTooltip="contenidoTooltip"
        @click_feature="clickEntidad"
      />

      <DaiCapaGeojson
        v-if="verCapas && nivelActual==='x-municipios'"
        :url="cvegeo==undefined? geojsonMunicipal: undefined"
        :datos="cvegeo==undefined? undefined: {
          type: 'FeatureCollection',
          features: JSON.parse(municipios)
        }"
        :z-index="2"
        :estilo-capa="{
          fill: {color: 'transparent'},
          stroke: {color: '#4CA345', width: .5},
        }"
        :contenidoTooltip="contenidoTooltip"
        :zoom-al-dar-click="false"
        @click_feature="clickEntidad"
      />

      <DaiCapaGeojson 
        v-if="verCapas"
        id="herbicidas"
        :datos="{type: 'FeatureCollection', features: JSON.parse(herbicidas)}"
        :z-index="3"
        :reglas-estilo-capa="[{
          clasificacion: 'categorias',
          columna: 'tipo',
          propiedadObjetivo: 'relleno',
          colores: ['#F7523A','#367E3E'],
          acomodoCategorias: ['Químico','Orgánico']
        },{
          clasificacion: 'personalizada',
          propiedadObjetivo: 'proporcion',
          columna: 'has',
          clasificacionPersonalizada: [[1,2500],[2500,25000],[25000,50000],[50000,
            nivelActual==='x-estados'? 556010: 97900]],
          proporciones: [3,6,9,12],
          clases: 4,
          tituloVariable: 'Hectáreas de cultivos'
        }]"
        :opacidad=".7"
        :contenidoTooltip="contenidoTooltip"
        :zoom-al-dar-click="false"
        @click_feature="clickEntidad"
      />
    </DaiMapa>

    <template #footer>
      <DaiLeyendaMapa style="min-height: 210px;"
        class="leyenda-reverse"
        para="herbicidas"
        titulo="Tipo de herbicida"
      />

      <hr class="dai-map-separator thin">

      <div class="dai-map-notes">
        <p>
          Muestra el número de hectáreas por entidad y municipios en las 
          cuales se utiliza herbicida químico u orgánico.
        </p>
        <p><b>Fuente: </b>INEGI, Censo Agrícola, Ganadero y Forestal 2007.</p>
      </div>

      <hr class="dai-map-separator thin">
      <a class="dai-map-button download" :href="`${cdnArchivos}/cultivos_uso_herbicidas.zip`" download>
        Descargar datos
      </a>
    </template>
  </DaiTarjetaContenedorMapa>
</template>

<script>
import { leerGeoJSON } from './_utils.js'
import Loader from '@/components/utiles/Loader.vue'

const diccionario = {
  tot_her_qu: {titulo: 'Químico', color: '#F7523A'},
  tot_her_or: {titulo: 'Orgánico', color: '#367E3E'}
},
nivelesMapa = ['x-estados', 'x-municipios'],
rutaDatos = 'data/mapa-herbicidas'

function prepararHerbicidas(features) {
  return Object.entries(diccionario)
    .map(([key,val]) => features
      .filter(f => f.properties[key]!=null||f.properties[key]!=0)
      .map(f => ({...f, ...{properties: {
        ...f.properties, ...{tipo: val.titulo, has: f.properties[key]}
      }}})
    )
  ).flat()
}

export default {
  data() { return {
    diccionario: diccionario,
    nivelActual: nivelesMapa[0],
    geojsonEstatal: `${rutaDatos}/capa_estatal_mapa3_mgn2020_simplificado.geojson`,
    geojsonMunicipal: `${rutaDatos}/capa_mapa3_herbicidas_mgn2020.geojson`,
    geojsonHerbicidasEstatal: `${rutaDatos}/centroides_herbicidas_estatales.geojson`,
    geojsonHerbicidasMunicipal: `${rutaDatos}/centroides_herbicidas.geojson`,
    estados: '[]',
    municipios: '[]',
    herbicidas: '[]',
    cvegeo: undefined,
    verCapas: false,
    cargando: true,
    cdnArchivos:  `${process.env.VUE_APP_CDN_ARCHIVOS}/impactos`,
  }},
  mounted() {
    this.cargarCapas()
  },
  computed: {},
  methods: {
    cargarCapas() {
      this.verCapas = false
      this.cargando = true
      if (this.cvegeo == undefined) {
        leerGeoJSON(this.nivelActual===nivelesMapa[0]
          ? this.geojsonHerbicidasEstatal: this.geojsonHerbicidasMunicipal
        ).then(data => {
          this.herbicidas = JSON.stringify(prepararHerbicidas(data.features))

          this.estados = '[]'
          this.municipios = '[]'
          this.esconderLoader()
        })
      } else {
        leerGeoJSON(this.geojsonHerbicidasMunicipal).then(data => {
          this.herbicidas = JSON.stringify(prepararHerbicidas(data.features
            .filter(f => f.properties.cvegeo.substr(0,2)===this.cvegeo)))

          leerGeoJSON(this.geojsonEstatal).then(data => {
            this.estados = JSON.stringify(data.features
              .filter(f => f.properties.cvegeo === this.cvegeo))

            leerGeoJSON(this.geojsonMunicipal).then(data => {
              this.municipios = JSON.stringify(data.features
                .filter(f => f.properties.cvegeo.substr(0,2)===this.cvegeo))
              
              this.nivelActual = nivelesMapa[1]
              this.esconderLoader()
            })
          })
        })
      }
    },
    contenidoTooltip(f) {
      return `<b class="renglon-tooltip">
          ${f.nom_mun? `${f.nom_mun}, ${f.nom_ent}`: f.nom_ent}
        </b><br>${Object.entries(diccionario)
          .map(([key,val]) => `<span class="renglon-tooltip">
            <span class="indicador-tooltip" style="background-color: ${val.color}"></span>
            ${val.titulo}: ${f[key]!=null? `${f[key].toLocaleString('en')} hectáreas`: 'Sin dato'}
          </span>`).join('<br>')}`
    },
    clickEntidad([f,]) {
      if (this.nivelActual===nivelesMapa[0]) {
        this.cvegeo = f.get('cvegeo')
        this.cargarCapas()
      }
    },
    verMunicipios() {
      if (this.nivelActual===nivelesMapa[0]) {
        this.nivelActual = nivelesMapa[1]
        this.cargarCapas()
      } else {
        this.nivelActual = nivelesMapa[0]
        this.cargarCapas()
      }
    },
    resetMap() {
      /** Escenarios:
       * 1. Estado seleccionado (nivel municipal)
       * 2. Nivel municipal sin estado seleccionado
       * 3. Nivel estatal
       */
      if (this.cvegeo != undefined) { // Escenario 1
        this.nivelActual = nivelesMapa[0]
        this.cvegeo = undefined
        this.cargarCapas()
      } else if (this.nivelActual===nivelesMapa[1]) { // Escenario 2
        //console.log('Escenario 2');
      } else { // Escenario 3
        //console.log('Escenario 3');
      }
    },
    esconderLoader() {
      setTimeout(() => {
        this.verCapas = true
        setTimeout(() => {
          this.cargando = false
        }, this.nivelActual===nivelesMapa[0]? 1000: 2000)
      }, 500)
    },
  },
  components: {
    Loader,
  },
}
</script>

<style lang="scss">
  .fix {
    overflow: hidden;
  }
</style>
